import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-likert-scale-1',
  templateUrl: './disable-likert-scale-1.component.html',
  styleUrls: ['./disable-likert-scale-1.component.css'],
})
export class DisableLikertScale1Component {
  @Input() question!: Question;
}
